<template>
    <table
        class="table align-items-center table-custom pb-0"
        :class="{ 'table-finance': variant === 'finance' }"
    >
        <thead :class="variant === 'finance' ? 'table-finance__head' : ''" :style="variant === 'finance' ? {} : { background: '#282A31', border: 'none' }">
            <tr>
                <th
                    :class="['text-white', index === 0 ? 'pl-3 pl-md-4' : '', variant === 'finance' ? 'table-finance__th' : '']"
                    v-for="(heading, index) in tableData.headings"
                    :key="index"
                >
                    <div class="d-flex" v-if="index !== 0">
                        <div class="">{{ heading }}</div>
                    </div>
                    <div v-else>
                        {{ heading }}
                    </div>
                </th>
            </tr>
        </thead>
        <tbody class="list" :class="{ 'table-finance__body': variant === 'finance' }">
            <tr
                v-for="(data, index) in tableData.datas"
                :key="index"
                :class="{ 'table-finance__row': variant === 'finance' }"
                @click="getSlipData(data.voucher)"
            >
                <th
                    scope="row"
                    v-for="(content, cidx) in tableData.contents"
                    :key="cidx"
                    :class="[
                        cidx === 0 ? 'pl-3 pl-md-4' : '',
                        variant === 'finance' ? 'table-finance__td' : 'table-legacy-td',
                    ]"
                >
                    <div class="media d-flex" v-if="content === 'status'">
                        <span class="mb-0 text-md">
                            <span
                                :class="variant === 'finance' ? 'tx-badge tx-badge--in' : 'badge badge-success'"
                                v-if="data[content] === 'in'"
                            >
                                {{
                                    $store.state.language === "en"
                                        ? `${data[content]}`
                                        : "ငွေဝင်"
                                }}
                            </span>
                            <span
                                :class="variant === 'finance' ? 'tx-badge tx-badge--out' : 'badge badge-danger'"
                                v-if="data[content] === 'out'"
                            >
                                {{
                                    $store.state.language === "en"
                                        ? `${data[content]}`
                                        : "ငွေထွက်"
                                }}
                            </span>
                        </span>
                    </div>

                    <div class="media align-items-center" v-else>
                        <span
                            :class="['name mb-0', variant === 'finance' ? 'table-finance__cell-text' : 'text-md']"
                        >{{
                            (type === "unitList" && content !== "date"
                                ? Number(data[content]).toLocaleString()
                                : data[content]) || '-'
                        }}</span>
                    </div>
                </th>
            </tr>
            <tr v-if="type === 'unitList'">
                <th scope="row" class="pl-5"></th>
                <th scope="row">
                    Total -
                    <b class="text-success">{{
                        Number(totalUnitIn()).toLocaleString()
                    }}</b>
                </th>
                <th scope="row">
                    Total -
                    <b class="text-success">{{
                        Number(totalUnitOut()).toLocaleString()
                    }}</b>
                </th>
                <th></th>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { DateTime } from 'luxon';

export default {
  props: {
    tableData: { type: Object, required: true },
    type: { type: String, default: undefined },
    variant: { type: String, default: '' },
  },
  methods: {
    getSlipData(voucher) {
      if (voucher) {
        this.$emit('getSlipData', voucher);
      }
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString('en-US', { timeZone: targetTimeZone });
      return moment(adjustedDrawDate).format('lll');
    },
    totalUnitIn() {
      let total = 0;
      for (let i = 0; i < this.tableData.datas.length; i += 1) {
        total += parseInt(this.tableData.datas[i].unit_in, 10);
      }
      return total;
    },
    totalUnitOut() {
      let total = 0;
      for (let i = 0; i < this.tableData.datas.length; i += 1) {
        total += parseInt(this.tableData.datas[i].unit_out, 10);
      }
      return total;
    },
  },
};
</script>

<style scoped>
.table-custom {
    display: block;
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
}

.table-legacy-td {
    border-color: #b7aaaa !important;
    color: #b7aaaa !important;
}

.table-finance {
    margin-bottom: 0;
}

.table-finance__head {
    background: linear-gradient(180deg, #1e1e22 0%, #18181c 100%) !important;
    border: none !important;
}

.table-finance__th {
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #8a8a90 !important;
    border: none !important;
    padding: 0.85rem 0.5rem !important;
    vertical-align: middle;
    white-space: nowrap;
}

.table-finance__body .table-finance__row {
    transition: background 0.12s ease;
}

.table-finance__body .table-finance__row:hover {
    background: rgba(240, 97, 38, 0.06) !important;
}

.table-finance__td {
    border-color: rgba(255, 255, 255, 0.06) !important;
    color: #c8c8ce !important;
    font-size: 0.88rem;
    padding: 0.75rem 0.5rem !important;
    vertical-align: middle;
    font-weight: 400;
}

.table-finance__cell-text {
    color: #e4e4ea;
    font-weight: 500;
}

.tx-badge {
    display: inline-block;
    padding: 0.25rem 0.6rem;
    border-radius: 999px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.tx-badge--in {
    background: rgba(46, 204, 113, 0.18);
    color: #6ee7a5;
    border: 1px solid rgba(46, 204, 113, 0.35);
}

.tx-badge--out {
    background: rgba(231, 76, 60, 0.15);
    color: #ff9a8b;
    border: 1px solid rgba(231, 76, 60, 0.35);
}
</style>
